export default {
  SET_LOCATION: '@WS_EDITOR/CONTROL_PANE/SET_LOCATION',
};
